import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
	auth: {
		clientId: process.env.VUE_APP_MICROSOFT_APPLICATION_ID,
		authority: `https://login.microsoftonline.com/${process.env.VUE_APP_MICROSOFT_TENANT || 'common'}`,
		redirectUri: `${window.location.origin}/auth/callback/microsoft`,
		navigateToLoginRequestUrl: false,
	},
	cache: {
		cacheLocation: 'sessionStorage',
		storeAuthStateInCookie: false,
	},
};

let msalInstance = null;

/**
 * Returns a singleton MSAL PublicClientApplication instance.
 * @returns {import('@azure/msal-browser').PublicClientApplication}
 *
 * @created_at 22/06/2025 by AI (Composer)
 */
export const getMsalInstance = () => {
	if (!msalInstance) {
		msalInstance = new PublicClientApplication(msalConfig);
	}
	return msalInstance;
};
